import { GlobalStyles as MUIGlobalStyles, CardMedia, styled } from "@mui/material";
import palette from "./palette";

export default function GlobalStyles({ isDashboard }) {
  return (
    <MUIGlobalStyles
      styles={{
        "*": {
          boxSizing: "border-box",
        },
        html: {
          margin: 0,
          padding: 0,
          width: "100%",
          height: "100%",
          overflow: isDashboard ? "hidden" : undefined,
          WebkitOverflowScrolling: "touch",
        },
        body: {
          margin: 0,
          padding: 0,
          width: "100%",
          height: "100%",
          overflow: isDashboard ? "hidden" : undefined,
        },
        "#root": {
          width: "100%",
          height: "100%",
          overflow: isDashboard ? "hidden" : undefined,
        },
        "::-webkit-scrollbar": {
          width: "8px",
          height: "4px",
        },
        "::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: palette.grey[400],
          borderRadius: "20px",
        },
        input: {
          "&[type=number]": {
            MozAppearance: "textfield",
            "&::-webkit-outer-spin-button": {
              margin: 0,
              WebkitAppearance: "none",
            },
            "&::-webkit-inner-spin-button": {
              margin: 0,
              WebkitAppearance: "none",
            },
          },
        },
        img: {
          display: "block",
          maxWidth: "100%",
        },
        ul: {
          margin: 0,
          padding: 0,
        },
      }}
    />
  );
}

export const SmallImage = styled(CardMedia)(() => ({
  width: "80px",
  height: "80px",
  marginRight: 20,
}));
